<template>
	<div class="d-flex align-items-center" :style="'height: ' + pc.iconHeight + 'px; width: auto;'">

      <img v-if="pc.backup_license_status == 1 && $root.connectionsStates[pc.id]"
      src="/assets/img/icons/one_icons/logo_one.svg"
      data-role="hint" :data-hint-position="hintPosition" :data-hint-text="'Iperius One ' + (pc.version_backup?pc.version_backup:'')"
      alt="Iperius One"/>

      <img v-if="pc.backup_license_status == 1 && !$root.connectionsStates[pc.id]"
      src="/assets/img/icons/one_icons/logo_one_grey.svg"
      data-role="hint" :data-hint-position="hintPosition" :data-hint-text="$t(pc.notConnectedDefaultMessage)"
      alt="Iperius One"/>
      
      <img v-if="pc.backup_license_status == 2"
      src="/assets/img/icons/one_icons/logo_one_grey_restart.png"
      data-role="hint" :data-hint-position="hintPosition" :data-hint-text="$t(pc.notConnectedDefaultMessage)"
      alt="Iperius One"/>
      
      <img v-if="pc.backup_license_status == 3"
      src="/assets/img/icons/one_icons/logo_one_grey_licence_removed.png"
      data-role="hint" :data-hint-position="hintPosition" :data-hint-text="$t(pc.notConnectedDefaultMessage)"
      alt="Iperius One"/>
   </div>
</template>
<script>

export default {
    name: "PCLink",
    props: {
        pc: {
            type: Object,
            required: true
        },
        hintPosition: {
            type: String,
            default: "top"
        },
    }
}
</script>
